'use strict';
import React from 'react';
import {InitialsAvatar} from './InitialsAvatar';

export function Event(data) {
  const event = data.event;
  // TODO: complete the layout here
  return (
    <span className="org-calendar-event">
      <span className="org-calendar-event-title">
        {event.title}
      </span>
      {InitialsAvatar(data.event.task.assignedTo)}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/Event.js